var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.1133V9.23828C9.75 8.07796 9.28906 6.96516 8.46859 6.14469C7.64812 5.32422 6.53532 4.86328 5.375 4.86328M9.75 16.1133H1V9.23828C1 8.07796 1.46094 6.96516 2.28141 6.14469C3.10188 5.32422 4.21468 4.86328 5.375 4.86328M9.75 16.1133V21.1133M5.375 4.86328H13.5M13.5 4.86328V1.11328H16.625M13.5 4.86328V8.61328M9.125 16.1133H21V8.61328C21 7.61872 20.6049 6.66489 19.9017 5.96163C19.1984 5.25837 18.2446 4.86328 17.25 4.86328M14.75 16.1133V21.1133M4.75 12.9883H6",
    stroke: "#FF395D",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.51a26e2f4d972dc0e73a11f1adda094c.svg";
export { ForwardRef as ReactComponent };